import { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import {
  PeriodicReportsState,
  UpdatePeriodicReportsFunction,
} from "./periodicReports.types";

export const initialState = (): PeriodicReportsState => {
  return {
    //Response for izvestajIsporuceneMarkiceDuvan
    tobaccoReport: { cigareteReport: [], nesagorevajuciReport: [] },
    coffeeReport: [],
    alcoholReport: [],
    hasTobaccoCategory: { hasCigarete: false, hasNesagorevajuci: false },
    hasCoffeeCategory: false,
    hasAlcoholCategory: false,
    showProcessButton: false,
    repeatProcess: false,
    period: [],
    PeriodId: null,
  };
};

interface IPeriodicReportsContext {
  periodicReports: PeriodicReportsState;
  setPeriodicReports: UpdatePeriodicReportsFunction;
  clearPeriodicReportsState: () => void;
}

export const PeriodicReportsContext = createContext<IPeriodicReportsContext>(
  null as any
);

export const PeriodicReportsContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [periodicReports, setPeriodicReportsState] = useState(initialState());

  const handleSetPeriodicReports = (
    updatedState: Partial<PeriodicReportsState>
  ) => {
    setPeriodicReportsState((prev) => ({ ...prev, ...updatedState }));
  };

  const setPeriodicReports = (updatedState: Partial<PeriodicReportsState>) => {
    handleSetPeriodicReports({ ...updatedState });
  };

  const clearPeriodicReportsState = () => {
    setPeriodicReportsState(initialState());
  };

  return (
    <PeriodicReportsContext.Provider
      value={{ periodicReports, setPeriodicReports, clearPeriodicReportsState }}
    >
      {children}
    </PeriodicReportsContext.Provider>
  );
};
